export default "__VITE_ASSET__BO7ml_Qd__";